import { style } from 'typestyle';
import { CommonStyles } from '../../common/styles/CommonStyles';

export const HeaderStyles = style({
  height: '18px',
  padding: '18px 24px 12px',
  fontSize: '14px',
});

export const SearchTitleStyle = style({
  ...CommonStyles.Typography.titleFont,
  ...CommonStyles.Layout.TextEllipsis,
  lineHeight: '28px',
});

export const ActionContainerStyles = style({
  padding: '28px 24px 30px 24px',
});

export const Content = style({
  padding: '12px 24px',
});

export const MixedContentTypeResultStyles = style({
  ...CommonStyles.Typography.defaultFont,
  padding: '0 24px',
});

export const MixedContentSectionStyle = style({
  marginBottom: '12px',
});

export const MixedContentTitleStyle = style({
  fontSize: CommonStyles.Sizes.LargeFontSize + 'px',
  marginBottom: CommonStyles.Spacing.MediumSpace,
  $nest: {
    span: {
      marginLeft: '20px',
      fontSize: CommonStyles.Sizes.NormalFontSize + 'px',
    },
  },
});

export const MixedContentHeaderStyle = style({
  padding: '10px 5px 0px 0px',
  borderBottom: '1px solid ' + CommonStyles.Colors.DividerLineColor,
});

export const MixedContentLinkStyle = style({
  color: CommonStyles.Colors.HyperlinkBlue,
  fontSize: CommonStyles.Sizes.SmallFontSize + 'px',
  fontWeight: 'bold',
});

export const SingleContentTypeResultStyles = style({
  ...CommonStyles.Typography.defaultFont,
  padding: '0 24px',
});

export const EmptyStateStyle = style({
  ...CommonStyles.Typography.defaultFont,
  fontSize: '14px',
  textAlign: 'center',
  lineHeight: '1.5',
  $nest: {
    svg: {
      display: 'block',
      margin: '0 auto',
      paddingBottom: '32px',
    },
  },
});

export const EmptyStateTitleStyle = style({
  fontSize: '18px',
  marginBottom: '16px',
  lineHeight: '1.5',
  color: CommonStyles.Colors.Grey51,
});

export const EmptyStateSubTitleStyle = style({
  fontSize: '14px',
  marginBottom: '16px',
  color: CommonStyles.Colors.Grey79,
});

export const DisplayModeChildrenStyle = style({
  float: 'left',
});
